"use client"

import CutEmeraldsHeader from "./cut-emeralds-header"
import CutEmeraldsGrid from "./cut-emeralds-grid"

export default function CutEmeraldsPage() {
  return (
    <div className="min-h-screen bg-neutral-50">
      <CutEmeraldsHeader />
      <CutEmeraldsGrid />
    </div>
  )
}
